import React from "react";
import * as stores from '../stores';

export const storesContext = React.createContext(stores);